import { IconButton } from "@mui/material";
import { CloseOutlined, Search } from "@mui/icons-material";
import { addClass } from "../GWidget";
import GTextField, { type IGTextFieldProps } from "./GTextField";

export interface ISearchFieldProp extends IGTextFieldProps {
    onClear?:()=>void;
    children?:JSX.Element | JSX.Element[]
}
export default function AGSearchField(props:ISearchFieldProp) {
    const {children,onClear,...textProps} = props
    const clear = textProps.value ? <IconButton className="small end" onClick={onClear}><CloseOutlined/></IconButton> : null
    return <div className={addClass("searchfield", props)}>
        <Search/>
        <GTextField {...textProps}/>
        {clear}
        {children}
    </div>
}